export const END_TIME_ADJUSTMENT = [3, 'hours'];
